import React from "react"
import {Backdrop, CircularProgress, styled} from "@material-ui/core";

const StyledBackdrop = styled(Backdrop)(p => ({
  zIndex: p.theme.zIndex.drawer+1
}))

export const Loading = () => {

  return (
    <>
      <StyledBackdrop open>
        <CircularProgress color='secondary' />
      </StyledBackdrop>
    </>
  )
}
